import { Injectable, signal } from "@angular/core";
import { of, Observable, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FeatureToggleService {

    featureToggles = signal<string[]>([]);

    /**
     * TODO: Replace return value with call to either keycloak services or FT table
     * 
     * - UAM/Keycloak role
     * @returns string list of feature toggles active
     */
    public getFeatureToggles(): Observable<string[]> {
        return of(["FT_OI_DOCPOP", "FT_TEST"]).pipe(tap((features) => this.featureToggles.set(features)));
    }

    public getFeatureToggle(feature: string): boolean {
        return this.featureToggles().find((x) => x === feature) !== undefined;
    }
}